import { render, staticRenderFns } from "./CadastreFixSizeTypeList.vue?vue&type=template&id=66e3601c&scoped=true&"
import script from "./CadastreFixSizeTypeList.vue?vue&type=script&lang=js&"
export * from "./CadastreFixSizeTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3601c",
  null
  
)

export default component.exports